export class NotificationConfig {
  title: string;
  statement: string;
}
